import { Modal } from "./";
import { CustomButton } from "./";
import { COLORS, levelcolors } from "../constants";
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import {
    EmailShareButton,
    FacebookShareButton,
    TwitterShareButton,
    WhatsappShareButton,
} from "react-share";

import {
    EmailIcon,
    FacebookIcon,
    TwitterIcon,
    WhatsappIcon,
} from "react-share";

import axios from "axios";
export function ShareModal(props) {
    const api = process.env.REACT_APP_API_URL;
    const user = useSelector(state => state.auth.user)

    const [quote, setQuote] = useState("");


    useEffect(() => {
        let pupil_id;
        if (props.pupil) {
            pupil_id = props.pupil;
        } else {
            pupil_id = user.user.pupil_id;

        }
        async function fetchData() {
            const response = await axios.get(`${api}/cp/pupil_words_by_level/${pupil_id}`);
            let wordsLearned = response.data.words_learned_by_level;
            let string = "";
            if (user.user_role == 1) {
                string = "my child has been";
            } else {
                string = "I have been";
            }
            let award_string = "";

            if (wordsLearned[props.levelno - 1].words_learned >= 100 && wordsLearned[props.levelno - 1].words_learned < 200) {
                award_string = "bronze";
            } else if (wordsLearned[props.levelno - 1].words_learned >= 200 && wordsLearned[props.levelno - 1].words_learned < 300) {
                award_string = "silver";
            } else if (wordsLearned[props.levelno - 1].words_learned == 300) {
                award_string = "gold";
            }
            if (award_string != "") {
                setQuote(`Hi there, ${string} awarded by ${award_string} rosette in Level ${props.levelno}. Let's join the Tell and Spell app!`);
            } else {
                if (user.user_role == 1) {
                    setQuote(`Hi there, my child is near to achieve bronze rosette in Tell and Spell application. Let's join us!`);
                } else {
                    setQuote(`Hi there, I'm near to achieve bronze rosette in Tell and Spell application. Let's join me!`);
                }

            }

        }
        fetchData();
    }, []);

    useEffect(() => {







    }, [])
    return (
        <Modal modalVisible={props.visible} onClose={props.onClose} width="40%">
            <h5 className="color-text-dark-blue">Share Progress</h5>
            {user.user_role == 1 ? <div>Share your child's progress with the friends on social media!</div> : <div>Share your progress with the friends on social media!</div>}


            <div className="mt-3">
                <ul className="list-unstyled">
                    <li>
                        <FacebookShareButton
                            url={"https://app.tellandspell.com/"}
                            quote={quote}
                            hashtag="#tellandspell"
                            className="mr-1"

                        >
                            <FacebookIcon size={40} round={true} />
                        </FacebookShareButton>
                        <span className="color-text-grey">Share to Facebook</span>
                    </li>

                    <li className="mt-1">
                        <TwitterShareButton
                            url={"https://app.tellandspell.com/"}
                            subject={"Preferred Subject"}
                            hashtag="#tellandspell"
                            body={quote}
                            title={"Tell and Spell"}
                            className="mr-1"
                        >
                            <TwitterIcon size={40} round={true} />
                        </TwitterShareButton>
                        <span className="color-text-grey">Share to Twitter</span>
                    </li>
                    <li className="mt-1">
                        <WhatsappShareButton
                            url={"https://app.tellandspell.com/"}
                            subject={"Preferred Subject"}
                            hashtag="#tellandspell"
                            quote={quote}
                            title={"Tell and Spell"}
                        >
                            <WhatsappIcon size={40} round={true} />
                        </WhatsappShareButton>
                        <span className="color-text-grey" style={{ marginLeft: 4 }}>Share to Whatsapp</span>
                    </li>
                    <li className="mt-1">
                        <EmailShareButton
                            url={"https://app.tellandspell.com/"}
                            subject={"Preferred Subject"}
                            hashtag="#tellandspell"
                            body={quote}
                            className="mr-1"

                        >
                            <EmailIcon size={40} round={true} />
                        </EmailShareButton>
                        <span className="color-text-grey">Share via Email</span>
                    </li>
                </ul>
                <div className="text-right">
                    <CustomButton
                        bgColor={COLORS.orange}
                        hover={COLORS.orange_hover}
                        color={COLORS.dark_orange}
                        onClick={props.onClose}
                        style={{ padding: "0 15px", height: 40, fontSize: 15, width: 100 }}
                    >
                        Cancel
                    </CustomButton>
                </div>



            </div>
        </Modal>
    )
}
